mod.modules.define("InputSearchBase", function(fn) {

	fn.prototype.init = function() {
		this.el.defaultValue();
	};

});